export default __webpack_public_path__ + "locales/sr-Cyrl-RS/DeleteDialog.json?hash=a99b1c11fc8071e7c95dbd9698ac44d6";